export enum LocationKey {
  LOCATIONS = 'locations',
}
